import { useRouteError } from 'react-router-dom';
import { ErrorPage } from '../../pages/ErrorPage';
import ErrorPageV3 from '../../V3/pages/global/ErrorPageV3';

/**
 * ErrorRouterBoundary — Capture les erreurs dans le router React Router v6
 * Affiche ErrorPageV3 en V3, ErrorPage en V1/V2
 * Message générique en prod, détails techniques en debug uniquement
 */
export default function ErrorRouterBoundary() {
  const error = useRouteError();
  const VERSION = process.env.REACT_APP_VERSION || 'v3';
  const isDebug = process.env.REACT_APP_DEBUG === 'true';

  // Logs conditionnels (détails techniques dans la console uniquement)
  if (isDebug) {
    console.error('Router error caught:', error);
  } else {
    console.error('Error:', error?.message || error);
  }

  // Message utilisateur : toujours simple et rassurant
  const userMessage = "Une erreur inconnue s'est produite, nous sommes désolés. Veuillez réessayer.";

  // V3 : ErrorPageV3
  if (VERSION === 'v3') {
    return (
      <ErrorPageV3
        errorCode="Oups !"
        message={userMessage}
      />
    );
  }

  // V1/V2 : ErrorPage classique
  return (
    <ErrorPage
      errorCode="Oups !"
      message={userMessage}
    />
  );
}
